import React from 'react';
import './HtmlGames.css';

const HTML_GAMES = [
  {
    id: 'tetris',
    name: 'FORTRESS DEFENSE',
    description: 'Build epic fortress with falling battle blocks',
    icon: '🧩',
    type: 'html',
    status: 'active',
    trainingInfo: {
      difficulty: 'Recruit to General',
      features: 'Leaderboards, Daily Quests',
      gameMode: 'Puzzle & Reflexes',
      trainingType: 'Fortress Building',
      skillLevel: 'TACTICAL',
      category: 'Strategy'
    }
  },
  {
    id: 'snake',
    name: 'SERPENT WARFARE',
    description: 'Guide the battle serpent to devour enemies',
    icon: '🐍',
    type: 'html',
    status: 'active',
    trainingInfo: {
      difficulty: 'Scout Level',
      features: 'Power-ups, Boss Battles',
      gameMode: 'Agility & Growth',
      trainingType: 'Serpent Combat',
      skillLevel: 'AGILITY',
      category: 'Action'
    }
  },
  {
    id: 'space-shooter',
    name: 'GALACTIC WAR',
    description: 'Defend the galaxy from alien invasion',
    icon: '👾',
    type: 'html',
    status: 'coming-soon',
    trainingInfo: {
      difficulty: 'Veteran Pilot',
      features: 'Ship Upgrades, Epic Bosses',
      gameMode: 'Combat & Defense',
      trainingType: 'Space Warfare',
      skillLevel: 'COMBAT',
      category: 'Shooter'
    }
  }
];

const HtmlGames = ({ onNavigate }) => {
  return (
    <div className="html-games-grid">
      {HTML_GAMES.map((game) => (
        <div 
          key={game.id}
          className={`html-game-card ${game.status}`}
          onClick={() => game.status === 'active' && onNavigate(game.id)}
        >
          <div className="game-header">
            <div className="game-icon">{game.icon}</div>
            <div className="game-status-indicator">
              <div className={`status-dot ${game.status}`}></div>
              <span className="status-text">
                {game.status === 'active' ? 'ONLINE' : 'PREPARING'}
              </span>
            </div>
          </div>
          
          <div className="game-info">
            <h3 className="game-title">{game.name}</h3>
            <p className="game-description">{game.description}</p>
          </div>

          <div className="game-stats">
            <div className="stat-row">
              <span className="stat-label">DIFFICULTY</span>
              <span className="stat-value">{game.trainingInfo.difficulty}</span>
            </div>
            <div className="stat-row">
              <span className="stat-label">FEATURES</span>
              <span className="stat-value">{game.trainingInfo.features}</span>
            </div>
            <div className="stat-row">
              <span className="stat-label">TRAINING</span>
              <span className="stat-value">{game.trainingInfo.trainingType}</span>
            </div>
            <div className="stat-row">
              <span className="stat-label">CATEGORY</span>
              <span className="stat-value">{game.trainingInfo.category}</span>
            </div>
          </div>

          <div className="game-footer">
            <div className="difficulty-badge">
              <span className="difficulty-level">{game.trainingInfo.skillLevel}</span>
              <span className="difficulty-type">{game.trainingInfo.gameMode}</span>
            </div>
            
            <button className={`engage-button ${game.status}`}>
              {game.status === 'active' ? 'START TRAINING' : 'PREPARING'}
            </button>
          </div>

          <div className="training-indicator">
            <span>🎓 TRAINING MODE</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HtmlGames;